<template>
	<article class="pet-summary">
		<!-- ローディング -->
		<transition name="fade">
			<aside v-if="isLoading" class="pet-summary__loading">
				<webview-redraw-progress />
			</aside>
		</transition>
		<!-- /ローディング -->

		<!-- 日付バー -->
		<h1 class="pet-summary__title"><common-date-header :targetDate="targetDate" @reload="init" /></h1>
		<!-- /日付バー -->

		<!-- ステータス -->
		<section class="pet-summary__status">
			<div class="pet-summary__status--contents">
				<p class="pet-summary__status--contents-name">{{ computedStatusTextName }}</p>
				<p class="pet-summary__status--contents-value">
					{{ computedStatusValueTextName.mainText }}
					<span>{{ computedStatusValueTextName.value === 0 ? '--' : computedStatusValueTextName.value }}</span>
					{{ computedStatusValueTextName.subText }}
					<span class="status" :class="computedStatusValueTextName.value >= 30 && computedStatusValueTextName.value < 40 ? 'color-gold' : computedStatusValueTextName.value >= 40 ? 'color-red' : ''">
						{{ computedStatusValueTextName.status }}
					</span>
				</p>
			</div>
			<div class="pet-summary__status--icon">
				<svg @click="openModal(0)" width="16" height="16" viewBox="0 0 16 16" fill="none">
					<g clip-path="url(#clip0_1113_25126)">
						<path d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" fill="white" stroke="#1EBFBB"/>
						<path d="M7.37158 4.58957V3.19858H8.76258V4.58957H7.37158ZM7.37158 12.6672V6.10061H8.76258V12.6672H7.37158Z" fill="#1EBFBB"/>
					</g>
					<defs>
						<clipPath id="clip0_1113_25126">
							<rect width="16" height="16" fill="white"/>
						</clipPath>
					</defs>
				</svg>
			</div>
		</section>
		<!-- /ステータス -->

		<!-- レポート-->
		<div class="pet-summary__report">
			<!-- チャート -->
			<section class="pet-summary__report--chart">
				<bar-chart
					:labels="computedChartData.value_labels"
					:datapoints="computedChartData.value_data"
					:chartIndex="computedChartData.value_key"
					:chartType="'summary-report-log'"
					:displayType="displayType"
					:xUnit="computedChartData.x_unit"
					:chartBarsColor="computedChartData.chartBarsColor"
					:key="`summary-chart-${computedChartData.value_key}`"
				/>
			</section>
			<!-- /チャート -->

			<!-- 記録リスト -->
			<section class="pet-summary__report--list" v-if="computedSummaryListData.length >= 1">
				<ul>
					<li v-for="(data, index) in computedSummaryListData" :key="`pet-summary-index-time${index}`" :class="!data.valueColor ? 'line-color-gray' : `line-color-${data.valueColor}`">
						<p>{{ data.formatDate }}</p>
						<p>{{ data.stutsValue }}<span v-show="data.stutsSubValue" :class="!data.valueColor ? '' : `text-color-${data.valueColor}`">{{ data.stutsSubValue }}</span></p>
					</li>
				</ul>
			</section>
			<!-- /記録リスト -->

			<!-- データが存在しない場合 -->
			<section class="pet-summary__report--description" v-else>
				<p>※データがあるのに表示されていない場合、1日後に再度ご確認いただくとデータが表示されている可能性があります。</p>
			</section>
			<!-- /データが存在しない場合 -->

			<aside @click="openModal(1)" class="pet-summary__data-quality">健康データの精度について</aside>
		</div>
		<!-- /レポート-->

		<!-- お知らせ詳細モーダル -->
		<transition name="fade">
			<aside v-if="isVisibleModal" class="pet-summary__modal">
				<div class="pet-summary__modal--inner">
					<h2 class="pet-summary__modal--title">
						<svg @click="isVisibleModal = false" width="40" height="40" viewBox="0 0 40 40" fill="none">
							<path d="M9 9.72003L9.69862 9.02141L30.9995 30.2799L30.3009 30.9785L9 9.72003Z" fill="white"/>
							<path d="M9 30.324L30.3009 9.06558L30.9995 9.7642L9.69862 31.0227L9 30.324Z" fill="white"/>
						</svg>
						<span v-if="modalType === 0">
							{{
								`${actionId === '1' ? '直腸温(推定)' : actionId === '2' ? '休息' : actionId === '3' ? '活動量'
									: actionId === '4' ? '食事' : actionId === '5' ? '毛繕い' : actionId === '6' ? '水飲み' : actionId === '7' ? '排泄姿勢' : '安静時呼吸数'}について`
							}}
						</span>
						<span v-else>健康データの精度について</span>
					</h2>
					<div class="pet-summary__modal--body">
						<!-- 直腸温(推定) -->
						<p v-if="modalType === 0 && actionId === '1'">
							首周りの温度から独自のアルゴリズムを用いて直腸温の 推定を行なっています。<br>
							直腸温とは、通常動物病院で測定される体温のことで、 獣医師が診療の参考として用いる数値です。<br>
							犬猫の体温の平均値は人間と比べて高く、37℃〜39℃です。<br>
							興奮したり、活発に動くことで体温が高くなることがありますが、高体温が長く続いている場合何らかの異常が隠れている可能性があります (かかりつけの動物病院に相談するか、PetVoice専属の獣医師に相談することができます)。<br>
							<span>※体勢が変わったり、首輪と皮膚の距離が離れてしまうことで、COREの温度センサーがうまく働かないことがあります。<br>
							推定直腸温が著しく低く表示される場合は、首輪の締め具合を指2本入るくらいに調節することをお勧めします。</span>
						</p>
						<!-- /直腸温(推定) -->

						<!-- 休息 -->
						<p v-else-if="modalType === 0 && actionId === '2'">
							睡眠中・休憩中など何にもしていない時間です。<br>
							ぺットの動きをモーションセンサーで感知し、休息時間 を割り出しています。
						</p>
						<!-- /休息 -->

						<!-- 活動量 -->
						<p v-else-if="modalType === 0 && actionId === '3'">
							ペットの動きをモーションセンサーで感知し、活動時間 を割り出しています。<br>
							ペットは犬と猫、品種の違いだけではなく、性格によって活動量がそれぞれ違います。<br>
							高齢になり関節が痛い、調子が悪くて元気がないなどの場合に、活動量が低下するおそれがあります。<br>
							愛犬愛猫が普段どれくらい活動しているのか、きちんと理解し、観察してあげることが大切です。<br>
							<span>※ゆっくり動く動作の場合、活動時間として記録されな い場合があります。</span>
						</p>
						<!-- /活動量 -->

						<!-- 食事 -->
						<p v-else-if="modalType === 0 && actionId === '4'">
							ぺットが食べ物を食べる際の動きをモーションセンサー で感知し、AIが行動判定を行っています。<br>
							犬や猫といった動物種や個体差はありますが、食事を一度に食べきる場合や、少しずつ何度かに分けて食べきる場合など、動物はさまざまなスタイルで食事をとります。<br>
							同じように完食していても、いつもは一度で食べきる子 が、実はいつもと違って時間をかけて何度かに分けて完 食している、といったことがあるかもしれません。<br>
							この場合は単に食事のとり方が変わった可能性もありますが、食欲が低下した、もしくは口の中に痛みや違和感があって食べたくても一度で食べきれなくなった、などの変化が起きている可能性があります。<br>
							食事を完食しているかだけでなく、その食べ方でもぺットの状態を知ることができます。<br>
							<span>※おもちゃを噛んでいる時など、食事と似た動作であれ ばカウントされる場合があります。</span>
						</p>
						<!-- /食事 -->

						<!-- 毛繕い -->
						<p v-else-if="modalType === 0 && actionId === '5'">
							ぺットが毛繕いをする(皮膚を紙める) 行動をモーショ ンセンサーで感知し、AIが行動判定を行っています。<br>
							猫は被毛の手入れ、体温調節、ストレスの緩和、コミュ ニケーションなどの目的で毛繕いを行います。<br>
							それに対して犬はリラックスしたいとき、ストレスの緩和のために行います。<br>
							毛繕い行動自体は犬猫にとって正常な行動ですが、頻度が多くなってきた、ずっと同じ場所を舐めている、などの場合は、もしかすると皮膚のトラブルが起き ているのかもしれません。<br>
							実際に舐めている部分を観察することで、皮膚の変化などに早く気付くことができます。<br>
							<span>※自分の体以外を紙めている時など、毛繕いと似た動作 であればカウントされる場合があります。</span>
						</p>
						<!-- /毛繕い -->

						<!-- 水飲み -->
						<p v-else-if="modalType === 0 && actionId === '6'">
							ぺットが水を飲む際の動きをモーションセンサーで感知 し、AIが行動判定を行っています。<br>
							ぺットは犬と猫、品種の違いに加えて、年齢や性格、季 節や室温などによって飲水量に差があります。<br>
							しかし、普段と比べて明らかに多く水飲みをしている場合には、なんらかの病気が隠れているかもしれません。<br>
							記録された水飲み時間が増えてきている場合には、実際にどのくらいお水が減っているかも合わせて確認しましょう。<br>
							<span>※1回の水飲み時間が極端に短いとき(1~2秒)はカウント できない場合があります。</span>
						</p>
						<!-- /水飲み -->

						<!-- 排泄姿勢 -->
						<p v-else-if="modalType === 0 && actionId === '7'">
							ペットが排泄する際の姿勢をモーションセンサーで感知 し、AIが行動判定を行っています。<br>
							1日に排便や排尿する回数や時間はペットごとに個体差が ありますが、通常は日によって大きく変わることはありません。<br>
							普段よりも多く排泄姿勢をとっている場合には、消化管や膀胱にトラブルが生じている可能性があります。<br>
							実際にしている便や尿の状態を合わせて観察することで、病気の早期発見につながります。<br>
							<span>※実際には排泄していなくても排泄時と同様な姿勢を取 るとカウントされる場合があります。</span>
						</p>
						<!-- /排泄姿勢 -->

						<!-- 安静時呼吸数 -->
						<p v-else-if="modalType === 0 && actionId === '8'">
							睡眠中、休息中の呼吸数を独自の技術により推定しています。<br>
							活動中や興奮状態、体温が高い時は呼吸が速くなるため、安定した呼吸数を計測できません。<br>
							一方、安静時（睡眠中や休息中）呼吸数はそれらの影響が無く安定した値を計測できます。<br>
							安静時呼吸数が40回以上の場合、呼吸数を増加させる要因が隠れている可能性がありますので、かかりつけの動物病院またはPetVoice専属の獣医師にご相談ください。<br>
							<span>※通常は1日に数回取得できます。1日通して取得できない場合もありますが、週単位で大きく変化がないかチェックすることが重要です。</span>
						</p>
						<!-- /安静時呼吸数 -->

						<p v-else-if="modalType === 1">
							個体差や環境等の条件により健康データの精度が悪くなることがあります。<br>
							PetVoice開発メンバーのポメラニアンのピケちゃんを筆頭に、安定して高い精度の健康データを表示できるよう鋭意改善しております。
						</p>
					</div>
				</div>
			</aside>
		</transition>
		<!-- /お知らせ詳細モーダル -->

	</article>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PET_SUMMARY_DATA } from '@/store/modules/pet/mutation-types'

// Compornents
import WebviewRedrawProgress from '@/components/Molecules/WebviewRedrawProgress'
import CommonDateHeader from '@/components/Molecules/CommonDateHeader'
import BarChart from '@/components/Molecules/BarChart'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

const digit0 = 0 // 小数第一位四捨五入
const digit1 = 1 // 小数第二位四捨五入

export default {
	name: 'PetSummaryReport',
	components: {
		WebviewRedrawProgress,
		CommonDateHeader,
		BarChart
	},
	props: {
		petId: {
			type: String,
			required: true
		},
		actionId: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			isLoading: false,
			logDate: moment().hours(0).minute(0).second(0).millisecond(0).unix(),
			targetDate: moment().hours(0).minute(0).second(0).millisecond(0).unix(),
			displayType: 'day',
			summaryData: null,
			arrayStatusText: {
				'1': '直腸温(推定)',
				'2': '休息',
				'3': '活動量',
				'4': '食事',
				'5': '毛繕い',
				'6': '水飲み',
				'7': '排泄姿勢',
				'8': '安静時呼吸数'
			},
			isVisibleModal: false,
			modalType: 0
		}
	},
	created () {
		// URLパラメータから日付を取得、なければデフォルト値
		if (this.$route.query.date) {
			this.targetDate = moment.unix(parseInt(this.$route.query.date)).hours(0).minute(0).second(0).millisecond(0).unix()
			this.logDate = this.targetDate
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('pet', ['petSummaryData']),

		// 項目名
		computedStatusTextName () {
			return this.arrayStatusText[this.actionId]
		},

		// ステータス
		computedStatusValueTextName () {
			const statusValues = { mainText: '', value: 0, subText: '', status: '' }

			if (this.actionId === '1') {
				const average = this.summaryData ? this.numberToFixed(this.summaryData.average, digit1) : 0
				// 直腸温(推定)
				statusValues.mainText = '平均'
				statusValues.value = average
				statusValues.subText = '℃'
			} else if (this.actionId === '2' || this.actionId === '3' || this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
				// 休息、活動量、食事、毛繕い、水飲み、排泄姿勢
				if (this.displayType === 'day') {
					const total = this.summaryData ? this.numberToFixed(this.summaryData.total, digit1) : 0
					statusValues.mainText = '合計'
					const value = this.convertMinutesToHours(total)
					statusValues.value = value.number
					statusValues.subText = value.unit
				} else {
					const average = this.summaryData ? this.numberToFixed(this.summaryData.average, digit1) : 0
					statusValues.mainText = '平均'
					const value = this.convertMinutesToHours(average)
					statusValues.value = value.number
					statusValues.subText = value.unit
				}
			} else {
				// 安静時呼吸数
				const average = this.summaryData ? this.numberToFixed(this.summaryData.average, digit0) : 0
				statusValues.mainText = '平均'
				statusValues.value = average
				statusValues.subText = '回/分'
				if (average !== 0) {
					statusValues.status = average >= 30 && average < 40 ? '（やや多い）' : average >= 40 ? '（多い）' : '（正常）'
				}
			}

			return statusValues
		},

		// グラフ描画データ加工
		computedChartData () {
			// 初期化
			const chart = {
				value_labels: [],
				value_data: [],
				value_key: Math.round(Math.random() * 1000),
				x_unit: '',
				chartBarsColor: []
			}

			// データを表示しやすいように加工するメソッド（formatは日='H'、月='M'、曜日='d'）
			const getRecordsData = (array, format) => {
				const data = {}
				for (let i = 0, len = array.length; i < len; i++) {
					const item = array[i]
					data[moment.unix(item.date).format(format)] = {
						value: item.value
					}
				}
				return data
			}

			// データ整形（this.summaryDataがなくても表示する）
			const records = this.summaryData ? this.summaryData.records : []

			if (this.displayType === 'day') {	// 日表示
				const recordsData = getRecordsData(records, 'H')

				for (let i = 0; i < 24; i++) {
					const value = recordsData[i] ? recordsData[i].value : 0
					chart.value_labels.push(i)
					if (this.actionId === '1') {
						// 直腸温(推定)
						chart.value_data.push(value ? this.numberToFixed(value, digit1) : 0)
						// 直腸温（39度以上：赤）
						chart.chartBarsColor.push(value >= 39 ? '#F37E82' : '#8EDBEC')
					} else if (this.actionId === '2' || this.actionId === '3' || this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
						// 休息、活動量、食事、毛繕い、水飲み、排泄姿勢
						chart.value_data.push(value ? this.numberToFixed(value, digit1) : 0)
						chart.chartBarsColor = null
					} else {
						// 安静時呼吸数
						chart.value_data.push(value ? this.numberToFixed(value, digit0) : 0)
						// 安静時呼吸数（30回以上：黄、40回以上：赤）
						chart.chartBarsColor.push(value >= 30 && value < 40 ? '#F6B552' : value >= 40 ? '#F37E82' : '#8EDBEC')
					}
				}

				if (this.actionId === '1') {
					// 直腸温(推定)
					chart.x_unit = '(℃)'
				} else if (this.actionId === '2' || this.actionId === '3' || this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
					// 休息、活動量、食事、毛繕い、水飲み、排泄姿勢
					chart.x_unit = '(分)'
				} else {
					// 安静時呼吸数
					chart.x_unit = '(回)'
				}
			} else {	// 週、月、年表示
				const len = this.displayType === 'week' ? 7	// 週の場合は7日
					: this.displayType === 'month' ? records.length > 0 ? records.length : 28	// 月の場合はrecordsの長さ、recordsがなければ月の最小日数の28日
						: 12	// 年の場合は12ヶ月
				for (let i = 0; i < len; i++) {
					const record = records[i]
					const value = record ? record.value : 0
					chart.value_labels.push(i)
					// グラフが時間表記の場合は分を時間にフォーマットする
					if (this.actionId === '1') {
						// 直腸温(推定)
						chart.value_data.push(value ? this.numberToFixed(value, digit1) : 0)
						// 直腸温（39度以上：赤）
						chart.chartBarsColor.push(value >= 39 ? '#F37E82' : '#8EDBEC')
					} else if (this.actionId === '2' || this.actionId === '3') {
						// 休息、活動量
						// グラフが時間表記の場合は分を時間にフォーマットする
						const formatVal = parseFloat((value / 60).toFixed(digit1))
						chart.value_data.push(formatVal)
						chart.chartBarsColor = null
					} else if (this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
						// 食事、毛繕い、水飲み、排泄姿勢
						chart.value_data.push(value ? this.numberToFixed(value, digit1) : 0)
						chart.chartBarsColor = null
					} else {
						// 安静時呼吸数
						chart.value_data.push(value ? this.numberToFixed(value, digit0) : 0)
						// 安静時呼吸数（30回以上：黄、40回以上：赤）
						chart.chartBarsColor.push(value >= 30 && value ? '#F6B552' : value >= 40 ? '#F37E82' : '#8EDBEC')
					}
				}

				if (this.actionId === '1') {
					// 直腸温(推定)
					chart.x_unit = '(℃)'
				} else if (this.actionId === '2' || this.actionId === '3') {
					// 休息、活動量
					chart.x_unit = '(時間)'
				} else if (this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
					// 食事、毛繕い、水飲み、排泄姿勢
					chart.x_unit = '(分)'
				} else {
					// 安静時呼吸数
					chart.x_unit = '(回)'
				}
			}
			return chart
		},

		// リストデータ加工
		computedSummaryListData () {
			const records = this.summaryData ? this.summaryData.records : []

			if (this.actionId === '1') {
				// 直腸温(推定)
				for (let i = 0; i < records.length; i++) {
					const objFrom = moment.unix(records[i].date)
					const value = this.numberToFixed(records[i].value, digit1)
					if (this.displayType === 'day') {
						// 日
						records[i]['formatDate'] = objFrom.format('MM月DD日 H時')
					} else if (this.displayType === 'week' || this.displayType === 'month') {
						// 週、月
						records[i]['formatDate'] = objFrom.format('MM月DD日')
					} else if (this.displayType === 'year') {
						// 年
						records[i]['formatDate'] = `${i + 1}月`
					}
					records[i]['stutsValue'] = `${value}℃`
				}
			} else if (this.actionId === '2' || this.actionId === '3' || this.actionId === '4' || this.actionId === '5' || this.actionId === '6' || this.actionId === '7') {
				// 休息、活動量、食事、毛繕い、水飲み、排泄姿勢
				for (let i = 0; i < records.length; i++) {
					const objFrom = moment.unix(records[i].date)
					const value = this.numberToFixed(records[i].value, digit1)
					const formatValue = this.convertMinutesToHours(value)
					records[i]['stutsValue'] = `${formatValue.number}${formatValue.unit}`
					if (this.displayType === 'day') {
						// 日
						records[i]['formatDate'] = objFrom.format('MM月DD日 H時')
					} else if (this.displayType === 'week' || this.displayType === 'month') {
						// 週、月
						records[i]['formatDate'] = objFrom.format('MM月DD日')
					} else if (this.displayType === 'year') {
						// 年
						records[i]['formatDate'] = `${i + 1}月`
					}
					records[i]['valueColor'] = ''
				}
			} else {
				// 安静時呼吸数
				for (let i = 0; i < records.length; i++) {
					const objFrom = moment.unix(records[i].date)
					const value = this.numberToFixed(records[i].value, digit0)
					if (this.displayType === 'day') {
						// 日
						records[i]['formatDate'] = objFrom.format('MM月DD日 H時')
					} else if (this.displayType === 'week' || this.displayType === 'month') {
						// 週、月
						records[i]['formatDate'] = objFrom.format('MM月DD日')
					} else if (this.displayType === 'year') {
						// 年
						records[i]['formatDate'] = `${i + 1}月`
					}
					records[i]['stutsValue'] = `${value}回/分`
					records[i]['stutsSubValue'] = value >= 30 && value < 40 ? '（やや多い）' : value >= 40 ? '（多い）' : '（正常）'
					records[i]['valueColor'] = value >= 30 && value < 40 ? 'gold' : value >= 40 ? 'red' : ''
				}
			}

			return records
		}
	},
	methods: {
		// map Vuex actions
		...mapActions('pet', [SET_PET_SUMMARY_DATA]),

		// 初期化処理
		init (value) {
			this.displayType = value.type

			// from, toの設定
			const from = value.from
			const to = value.to

			this.getPetSummaryData(from, to, moment.unix(value.to).year())
		},

		getPetSummaryData (from, to, year) {
			this.isLoading = true

			// 年とそれ以外の表示でリクエスト内容を変える
			const request = {
				from: from,
				to: to,
				year: year
			}
			if (this.displayType === 'year') {
				request.from = null
				request.to = null
			} else {
				request.year = null
			}

			// リクエスト
			this.SET_PET_SUMMARY_DATA({
				user_id: this.userId,
				user_token: this.userToken,
				pet_id: this.petId,
				from_date: request.from,
				to_date: request.to,
				year: request.year,
				action_id: this.actionId
			}).then(res => {
				// console.log('petSummaryData: ', this.petSummaryData)
				this.summaryData = this.petSummaryData
			}).catch(error => {
				console.log('getSummaryData Error: ', error)
				this.summaryData = null
			}).finally(() => {
				this.isLoading = false
			})
		},

		// モーダル
		openModal (type) {
			this.modalType = type
			this.isVisibleModal = true
		},

		// 数値の四捨五入処理
		numberToFixed (number, digit) {
			const fixedNum = number.toFixed(digit)
			return parseFloat(fixedNum)
		},

		// 分または時間に変換
		convertMinutesToHours (m) {
			let val = { number: 0, unit: '' }
			if (m >= 60) {
				val.number = parseFloat((m / 60).toFixed(digit1))
				val.unit = '時間'
			} else {
				val.number = m
				val.unit = '分'
			}
			return val
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止
$color-pet-summary-primary: #23B3D2;
$color-pet-summary-gold: #F6B552;
$color-pet-summary-pink: #F37E82;

$spacing-24: 1.5rem;
$spacing-28: 1.75rem;
$spacing-32: 2rem;

$font-size-30: 1.875rem;
$font-size-32: 2rem;

.pet-summary {
	position: relative;
	width: 100%;
	font-family: $lp-family-primary;
	color: $text-primary;

	// mplusのジャギー対策
	p, span, em, a, h2, h3, option { transform: rotate(0.05deg); }

	&__title {
		margin: 0;
		padding: 0;
		background-color: $background-secondary;
	}

	&__status {
		padding: $spacing-8 $spacing-20;
		background-color: $background-secondary;
		display: flex;
		align-items: center;
		justify-content: space-between;
		&--contents {
			display: contents;
			&-name {
				color: $text-primary;
				font-family: $lp-family-secondary;
				font-size: $font-size-16;
				font-style: normal;
				margin: 0;
			}
			&-value {
				color: $color-pet-summary-primary;
				text-align: right;
				font-family: $lp-family-secondary;
				font-size: $font-size-14;
				font-style: normal;
				margin: 0;
				span {
					font-size: $font-size-32;
				}
				.status {
					color: $color-pet-summary-primary;
					font-family: $lp-family-secondary;
					font-size: $font-size-14;
					font-style: normal;
					margin: 0;
				}
				.color-gold {
					color: $color-pet-summary-gold;
				}
				.color-red {
					color: $color-pet-summary-pink;
				}
			}
		}
		&--icon {
			display: contents;
		}
	}

	&__report {
		max-width: 100%;
		padding: 0 0 $spacing-16;

		&--chart {
			width: 100%;
			margin: $spacing-24 auto 0;
			padding: 0 $spacing-20;
			background-color: $background-primary;
			box-sizing: border-box;
		}

		&--list {
			width: 100%;
			margin: $spacing-24 0 0;
			ul {
				width: 100%;
				margin: 0;
				padding: 0;
			}
			li {
				display: flex;
				width: 89.333%;
				margin: 0 auto;
				padding: $spacing-8;
				list-style: none;
				border-radius: 4px;
				p {
					margin: 0;
					color: $text-primary;
					font-family: $lp-family-primary;
					font-size: $font-size-14;
					font-style: normal;
				}
			}
			li > :first-child { flex-grow: 2 }
			li:not(:first-of-type){
				margin-top: $spacing-16;
			}

			.line-color-red {
				border: 1px solid $color-pet-summary-pink;
			}
			.line-color-gold {
				border: 1px solid $color-pet-summary-gold;
			}
			.line-color-gray {
				border: 1px solid $line-primary;
			}
			.text-color-red {
				color: $color-pet-summary-pink;
				font-family: $lp-family-secondary;
			}
			.text-color-gold {
				color: $color-pet-summary-gold;
				font-family: $lp-family-secondary;
			}
		}

		&--description {
			width: 100%;
			margin: $spacing-24 0 0;
			p {
				width: 89.333%;
				display: block;
				color: $text-primary;
				margin: 0 auto;
				font-family: $lp-family-primary;
				font-size: $font-size-12;
				font-style: normal;
				line-height: 1.5;
			}
		}
	}

	&__data-quality {
		margin: $spacing-32 auto 0;
		font-size: $font-size-12;
		font-family: $lp-family-secondary;
		text-align: center;
		text-decoration: underline;
	}

	// ローディング
	&__loading {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba($_black, 0.4);
		overflow: hidden;
		z-index: 9999;

		.redraw-progress {
			position: fixed;
			background: none;
			height: 100vh;
		}
	}

	// モーダル
	&__modal {
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		background: rgba($_black, .5);
		overflow: hidden;
		z-index: 9999;

		&--inner {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 94.6667%;
			box-sizing: border-box;
			background-color: $background-primary;
			border-radius: $spacing-10;
		}

		&--title {
			position: relative;
			margin: 0;
			padding: $spacing-8;
			background-color: $primary;
			font-family: $lp-family-tertiary;
			font-weight: normal;
			font-size: $font-size-18;
			color: $text-seconday;
			text-align: center;
			border-radius: $spacing-10 $spacing-10 0 0;

			svg {
				display: block;
				position: absolute;
				width: 40px;
				top: 50%;
				left: $spacing-8;
				transform: translateY(-50%);
				z-index: 1;
			}

			span {
				display: block;
				flex: 1;
				text-align: center;
			}
		}

		&--body {
			color: $text-primary;
			padding: $spacing-20;
			font-family: $lp-family-primary;
			font-size: $font-size-14;
			line-height: 1.5;

			& > p {
				margin: 0;
				span {
					display: block;
					margin-top: $spacing-28;
				}
			}
		}
	}
}

@media (max-width: (370px)) {
	.pet-summary {
		&__status {
			&--contents {
				&-name {
					font-size: $font-size-14;
				}
				&-value {
					font-size: $font-size-12;
					span {
						font-size: $font-size-30;
					}
					.status {
						font-size: $font-size-12;
					}
				}
			}
		}

		&__report {
			&--list {
				li {
					p {
						font-size: $font-size-12;
					}
				}
			}
			&--description {
				p {
					font-size: $font-size-10;
				}
			}
		}

		&__data-quality {
			font-size: $font-size-10;
		}

		// モーダル
		&__modal {
			&--title {
				font-size: $font-size-16;
			}

			&--body {
				font-size: $font-size-12;

				& > p {
					span {
						margin-top: $spacing-24;
					}
				}
			}
		}
	}
}

@media (max-width: (350px)) {
	.pet-summary {
		&__status {
			&--contents {
				&-name {
					font-size: $font-size-12;
				}
				&-value {
					font-size: $font-size-10;
					span {
						font-size: $font-size-30;
					}
					.status {
						font-size: $font-size-10;
					}
				}
			}
		}

		&__report {
			&--list {
				li {
					p {
						font-size: $font-size-10;
					}
				}
			}
			&--description {
				p {
					font-size: $font-size-8;
				}
			}
		}

		&__data-quality {
			font-size: $font-size-8;
		}

		// モーダル
		&__modal {
			&--title {
				font-size: $font-size-14;
			}

			&--body {
				font-size: $font-size-10;
				& > p {
					span {
						margin-top: $spacing-20;
					}
				}
			}
		}
	}
}

// アニメーション
.fade-enter-active, .fade-leave-active {
	transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
